import { type ReactNode } from 'react'
import { useTheme } from 'styled-components'

import { ListingPrice } from '@/components/srp/listing-card/listing-price'
import { type ListingCardPrice } from '@/components/srp/listing-card/types'
import { useRichCardLinkContext } from '@/features/listing/components/rich-card/RichCardLinkContext'
import {
  RichCardHeaderContainer,
  RichCardLink,
  RichCardTitle,
  RichCardTitleWrapper,
} from '@/features/listing/components/rich-card/styled'

type RichCardHeaderProps = {
  price: ListingCardPrice
  title: string | ReactNode
  url: string
  handleClick?: () => void
}

export const RichCardHeader = ({ price, title, url, handleClick }: RichCardHeaderProps) => {
  const { colors } = useTheme()
  const { openInNewTab } = useRichCardLinkContext()

  return (
    <RichCardHeaderContainer>
      <RichCardTitleWrapper>
        <RichCardTitle
          color={colors.grey.primary}
          data-testid="listing-title"
          forwardedAs="h3"
          size="medium"
        >
          <RichCardLink
            data-testid="rich-card-link"
            href={url}
            onClick={handleClick}
            rel={openInNewTab ? 'nofollow noopener noreferrer' : undefined}
            target={openInNewTab ? '_blank' : undefined}
          >
            {title}
          </RichCardLink>
        </RichCardTitle>
      </RichCardTitleWrapper>
      {price ? (
        <ListingPrice
          priceAmount={price.amount}
          priceOriginal={price.original}
          type={price.type}
          surcharges={price.surcharges}
        />
      ) : null}
    </RichCardHeaderContainer>
  )
}
